import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.function.name.js";
/// ///////////////////////////////////////////////////////////////////////
//                 acsaccount / Пользователи
/// ///////////////////////////////////////////////////////////////////////

import { i18n } from 'boot/i18n';
import { MODE, CARD, ENTRY } from 'pages/aftmixin';
import { aftInst as aft } from 'boot/aft';
import { locale2code } from 'components/LangSelector';
import { smaCompanyList } from 'pages/Refs/smaCompany';

// Предопределенные значения (коды) типов пользователя
export var USERTYPE = Object.freeze({
  exec: 'exec',
  cust: 'cust',
  smart: 'smart'
});

// Наименования предопределенных типов пользователя
var USERTYPELAB = Object.freeze({
  exec: 'acsaccount.lab.executor',
  cust: 'acsaccount.lab.customer',
  smart: 'acsaccount.lab.smart'
});
export function userTypeLab(utvalue) {
  return i18n.t(USERTYPELAB[utvalue]);
}

// ----------------------------------------------------------------------------
//                                curAccount()
//
// Возвращает объект с атрибутами текущего подключения:
//     ... accId
//     ... accLogin
//     ... accName
//     ... userType
//     ... langCode
//     ... roles
// Если авторизация не пройдена, возвращает null
// ----------------------------------------------------------------------------

export function curAccount() {
  if (!aft.g.auth.accId) {
    return null;
  }
  return aft.g.auth;
}
export default {
  data: function data() {
    return {
      exekind: null,
      exesel: null,
      exeopts: [{
        value: 'P',
        label: i18n.t('acsaccount.lab.kindP')
      }, {
        value: 'G',
        label: i18n.t('acsaccount.lab.kindG')
      }, {
        value: 'F',
        label: i18n.t('acsaccount.lab.kindF')
      }],
      typeopts: [{
        value: USERTYPE.cust,
        label: userTypeLab(USERTYPE.cust)
      }, {
        value: USERTYPE.exec,
        label: userTypeLab(USERTYPE.exec)
      }, {
        value: USERTYPE.smart,
        label: userTypeLab(USERTYPE.smart)
      }],
      kindLabel: {
        P: i18n.t('acsaccount.lab.kindPt'),
        G: i18n.t('acsaccount.lab.kindGt'),
        F: i18n.t('acsaccount.lab.kindFt'),
        N: ''
      },
      custdata: [],
      cust: null,
      custopts: [],
      rdata: [],
      recAdd: {
        id: null,
        login: null,
        name: null,
        usertype: 'cust',
        kind: 'P',
        psw: null,
        phone: null,
        email: null,
        isexecutor: 'N',
        custid: null,
        custname: null,
        jobposition: null,
        langcode: null,
        avafileId: null
      },
      recRse: {
        typesel: null,
        cust: null,
        exesel: null,
        login: null,
        name: null,
        phone: null,
        email: null,
        jobposition: null,
        Actual: 'Y'
      },
      aftobjDesc: {
        aftobjCode: 'acsaccount',
        aftobjAlias: 'acs',
        aftobjEntry: ENTRY.cardTab,
        aftobjMode: [MODE.inittab, MODE.recpage],
        aftchkFuncs: ['login', 'name'],
        aftobjActs: [
        // Row actions
        'actDelete', 'actResetPsw', {
          act: 'actHistory',
          icon: 'history',
          scope: 'row',
          fun: 'aftAction'
        }, {
          act: 'actFind',
          icon: 'search',
          scope: 'none'
        },
        // Table actions
        {
          act: 'actSwitchMarks',
          icon: '',
          scope: 'tab'
        }, {
          act: 'actDeleteM',
          icon: ''
        }, {
          act: 'actFreshAddle',
          icon: ''
        }, {
          act: 'actDeleteP',
          icon: ''
        }, {
          act: 'actRepairAddle',
          icon: ''
        }, {
          act: 'actExcel',
          icon: ''
        }],
        logicaldel: true
      }
    };
  },
  computed: {
    columns: function columns() {
      var _this = this;
      return [
      // { name: 'id', field: 'id', label: this.t('acsaccount.lab.id'), sortable: true },
      {
        name: 'aftRowActions',
        field: 'aftRowActions',
        /* label: this.t('com.lab.rowactions'), */sortable: false,
        align: 'left'
      }, {
        name: 'name',
        field: 'name',
        label: i18n.t('acsaccount.lab.name'),
        sortable: true,
        align: 'left'
      }, {
        name: 'login',
        field: 'login',
        label: i18n.t('acsaccount.lab.login'),
        sortable: true,
        align: 'left'
      }, {
        name: 'usertype',
        field: 'usertype',
        label: i18n.t('acsaccount.lab.type'),
        sortable: true,
        align: 'left',
        format: function format(val, row) {
          return userTypeLab(val);
        }
      }, {
        name: 'kind',
        field: 'kind',
        label: i18n.t('acsaccount.lab.executor'),
        sortable: true,
        align: 'left',
        format: function format(val, row) {
          return row.isexecutor === 'Y' ? _this.kindLabel[val] : '';
        }
      }, {
        name: 'custname',
        field: 'custname',
        label: i18n.t('acsaccount.lab.customerfirm'),
        sortable: true,
        align: 'left'
      }, {
        name: 'jobposition',
        field: 'jobposition',
        label: i18n.t('acsaccount.lab.jobposition'),
        sortable: true,
        align: 'left'
      }, {
        name: 'phone',
        field: 'phone',
        label: i18n.t('acsaccount.lab.phone'),
        sortable: true,
        align: 'left'
      }, {
        name: 'email',
        field: 'email',
        label: i18n.t('acsaccount.lab.email'),
        sortable: true,
        align: 'left'
      },
      // { name: 'roles', field: 'roles', label: i18n.t('acsaccount.lab.roles'), sortable: true, align:'left', style: 'max-width: 200px', classes: 'ellipsis' },
      {
        name: 'avaFileId',
        field: 'avaFileId',
        label: i18n.t('acsaccount.lab.ava'),
        sortable: false
      }

      // { name: 'ServerTimestamp', field: 'ServerTimestamp', label: this.t('acsaccount.lab.stamp'), sortable: true, format: (val,row) => this.bro2locale(new Date(val)) },
      // { name: 'UserName', field: 'UserName', label: this.t('acsaccount.lab.stampacc'), sortable: true }
      ];
    }
  },
  methods: {
    eventCapture: function eventCapture(evn, par) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgs, i, _i, _i2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(evn === 'evnInitCard')) {
                _context.next = 6;
                break;
              }
              _this2.aftpagination.sortBy = 'name';

              // Подготовим список организаций
              _context.next = 4;
              return smaCompanyList();
            case 4:
              orgs = _context.sent;
              if (orgs) {
                for (i = 0; i < orgs.length; i++) {
                  _this2.custopts.push({
                    value: orgs[i].id,
                    label: orgs[i].name
                  });
                }
              }
            case 6:
              if (evn === 'evnAfterRead') {
                // Установим execel & exekind по kind
                if (_this2.recAdd.kind) {
                  for (_i = 0; _i < _this2.exeopts.length; _i++) {
                    if (_this2.exeopts[_i].value === _this2.recAdd.kind) {
                      _this2.exesel = _this2.exeopts[_i];
                      _this2.exekind = _this2.exeopts[_i].label; // для cardView
                    }
                  }
                }
                // Установим acckind
                _this2.acckind = _this2.recAdd.isexecutor === 'Y' ? 'exec' : _this2.recAdd.custid ? 'cust' : 'smart';
                // Установим cust для cardUpd
                if (_this2.aftcard === CARD.upd) {
                  // await initCusts(this)
                  for (_i2 = 0; _i2 < _this2.custopts.length; _i2++) {
                    if (_this2.custopts[_i2].value === _this2.recAdd.custid) {
                      _this2.cust = _this2.custopts[_i2];
                    }
                  }
                }
                if (_this2.cust) {
                  _this2.recAdd.custname = _this2.cust.label;
                }
                // Инициализация списка ролей текущего пользователя
                // await this.aftDBAction('acsaccountrole', 'select', this.recAdd, 'rdata')
              }
              if (evn === 'evnBeforeInsert' || evn === 'evnBeforeUpdate') {
                // Если создаем нового пользователя, psw === login, langcode - current
                if (evn === 'evnBeforeInsert') {
                  _this2.recAdd.psw = _this2.recAdd.login.toLowerCase();
                  _this2.recAdd.langcode = locale2code(i18n.locale);
                }
                // Ссылка на компанию
                if (_this2.cust) {
                  _this2.recAdd.custid = _this2.cust.value;
                  _this2.recAdd.custname = _this2.cust.label;
                } else {
                  _this2.recAdd.custid = null;
                  _this2.recAdd.custname = null;
                }
                // Заказчик/исполнитель
                if (_this2.isexe) {
                  _this2.recAdd.kind = _this2.exesel.value;
                  _this2.recAdd.isexecutor = 'Y';
                } else {
                  _this2.recAdd.isexecutor = 'N';
                }
              }
              return _context.abrupt("return", true);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // Закрываем изменение системного пользователя с ИД = 1
    ownLicence: function ownLicence(act, row) {
      var accid = typeof row === 'undefined' ? this.recAdd.id : row.id;
      if (act === 'actUpdate' || this.aftStrIn(act, 'actDelete,actResetPsw') && !this.aftenv.selected.length) {
        return accid !== 1;
      }
      // Для actDelete и actResetPsw возможна групповая операция
      if ('actDelete,actResetPsw'.indexOf(act) !== -1) {
        for (var i = 0; i < this.aftenv.selected.length; i++) {
          if (this.aftenv.selected[i].id === 1) {
            return false;
          }
        }
      }
      ;
      return true;
    }
  }
};